import { render } from "./OptionsCreated.vue?vue&type=template&id=3fde1ac7"
import script from "./OptionsCreated.vue?vue&type=script&lang=js"
export * from "./OptionsCreated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__